import authReducer from './authReducer'
import projectReducer from './projectReducer'
import { combineReducers } from 'redux'
import { firestoreReducer } from 'redux-firestore'
import { firebaseReducer } from 'react-redux-firebase'




const rootReducer = combineReducers({
    auth:authReducer,
    project:projectReducer,
    //will sync our datat to the db
    firestore: firestoreReducer,
    firebase: firebaseReducer
});

export default rootReducer;
